import React from "react";
import { Card, Avatar, Tag } from "antd";
import { MailOutlined, BankOutlined, FileTextOutlined, DollarOutlined } from "@ant-design/icons";
import { formatDateTime } from "../../../../../utils/functions";
import { getInitials } from "../../../../../utils/helper";

const EnhancedPaymentHistoryCardView = ({
    record,
    onCardClick,
}) => {
    const initials = getInitials(record.User?.name || record.userEmail);

    return (
        <Card
            hoverable
            className="h-full relative transition-all duration-200"
            onClick={() => onCardClick && onCardClick(record)}
        >
            <div className="space-y-3 sm:space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-2 sm:space-x-3 overflow-hidden">
                        <Avatar
                            size={40}
                            className="flex-shrink-0 font-semibold text-base sm:text-lg !bg-primary sm:w-12 sm:h-12"
                        >
                            {initials}
                        </Avatar>
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-sm sm:text-base mb-1 truncate" title={record.User?.name}>
                                {record.User?.name || "N/A"}
                            </h3>
                            <div className="flex items-center text-xs sm:text-sm text-gray-500">
                                <MailOutlined className="mr-1 flex-shrink-0" />
                                <span className="truncate" title={record.userEmail}>
                                    {record.userEmail}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Body */}
                <div className="space-y-2">
                    <div className="flex items-center justify-between text-xs sm:text-sm text-gray-600">
                        <span className="font-medium">Payment At:</span>
                        <span>{formatDateTime(record.createdAt)}</span>
                    </div>

                    <div className="flex items-center justify-between text-xs sm:text-sm text-gray-600">
                        <span className="font-medium flex items-center gap-1"><BankOutlined /> Gateway:</span>
                        <span>{record.paymentGateway}</span>
                    </div>

                    <div className="flex items-center justify-between text-xs sm:text-sm text-gray-600">
                        <span className="font-medium flex items-center gap-1"><DollarOutlined /> Amount:</span>
                        <span className="font-bold text-gray-800 text-sm sm:text-base">${record.amount}</span>
                    </div>

                    {/* Description */}
                    <div className="pt-2 border-t border-gray-100 mt-2">
                        <div className="flex items-start gap-1 text-xs sm:text-sm text-gray-500">
                            <FileTextOutlined className="mt-1" />
                            <span className="line-clamp-2" title={record.description}>
                                {record.description || "No description"}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedPaymentHistoryCardView;
